module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"title":"Save Another Image?","confirm":"Do you want to save an image of other side of the document?","cancel":"Cancel","save":"Save","bookings":"bookings"},"sl":{"title":"Shrani še eno sliko?","confirmText":"Shrani še drugo stran dokumenta?","cancel":"Prekliči","save":"Shrani","bookings":"rezervacije"}}')
  delete Component.options._Ctor
}
